module.exports = __webpack_public_path__ + "static/media/AppStoreBlack (1).ea79b34f.png";